<script setup>
import {computed} from "vue";
import {useStore} from "vuex";

const store = useStore();
const user = computed(() => store.getters['user/user']);
</script>

<template>
  <div>
    <p class="tw-mb-2">
      Now that we’ve set up your strategy, I’m ready to jump in and start making real-time SEO improvements to your website.
    </p>
    <p class="tw-mb-3">
      All I need is the Optimizer snippet added to your site—then I can keep your SEO humming 24/7.
    </p>

    <p class="tw-mb-3">
      <strong>Just to be clear:</strong> You stay in control the whole time. While I may occasionally make small updates (such as technical adjustments) automatically, I’ll always seek your approval for all other SEO changes within the Approval Center.
    </p>

    <p class="tw-mb-2">
      Here’s what I’ll do once I’m live:
    </p>
    <p>
      ✅ <span class="tw-font-bold">Identify new SEO opportunities:</span> I analyze your site data so you can focus on your business.
    </p>
    <p>
      ✅ <span class="tw-font-bold">Implement updates:</span> I take care of the technical adjustments, ensuring your site stays optimized.
    </p>
    <p>
      ✅ <span class="tw-font-bold">Ensure ongoing compliance:</span> Every change I make adheres to the latest Google best practices.
    </p>
    <!-- Agency - Admin -->
    <p
      v-if="user.organisation_customer_type === 'AGENCY' && user.is_organisation_admin"
      class="tw-mb-3"
    >
      ✅ <span class="tw-font-bold">Provide lasting improvements:</span> Even if you cancel your Hike account, your optimizations will remain live on your site (as long as the snippet isn’t removed).
    </p>

    <!-- AppSumo - Admin / Merchant Center SME / Single -->
    <p
      v-if="
        (user.organisation_customer_type === 'APPSUMO' && user.is_organisation_admin)
          || ['SINGLE', 'MERCHANT_CUSTOMER'].includes(user.organisation_customer_type)
      "
      class="tw-mb-3"
    >
      ✅ <span class="tw-font-bold">Full Control:</span> Even if you cancel your Hike account, your optimizations will remain live on your site (as long as the snippet isn’t removed).
    </p>

    <!-- Vendasta Admin -->
    <p
      v-if="user.organisation_customer_type === 'VENDASTA' && user.is_organisation_admin"
      class="tw-mb-3"
    >
      ✅ <span class="tw-font-bold">Full Control:</span> Even if you cancel your Hike account, your optimizations will remain live on your site (as long as the snippet isn’t removed).
    </p>

    <!-- Vendasta Non Admin -->
    <p
      v-if="user.organisation_customer_type === 'VENDASTA'"
      class="tw-mb-3"
    >
      ✅ <span class="tw-font-bold">Flexibility:</span> Even if you cancel your Hike account, your optimizations will remain live on your site (as long as the snippet isn’t removed).
    </p>
  </div>
</template>
